$(document).ready(function () {
    let ajaxLockActive = false;

    const ajaxPathProductCategory = '/action/waiter-app/product-category';
    const ajaxPathProductCategorySearchProducts = '/products';
    const ajaxPathProductCategoryUpdateSortPriority = '/sort-priority';

    function updateSortPriority() {
        if (ajaxLockActive === true) {
            return;
        }

        ajaxLockActive = true;

        const productCategoryIds = [];
        $('#wa_product_category_wrapper .wa_product_category_item', document).each(function (_, element) {
            productCategoryIds.push($(element).attr('data-id'));
        });

        $.ajax({
            type: 'PATCH',
            url: ajaxPathProductCategory + ajaxPathProductCategoryUpdateSortPriority,
            data: {
                product_category_ids: productCategoryIds
            },
            dataType: 'json'
        }).success(function (data) {
            displayTailwindAlert('', 'Sorteringsprioritet er lagret', '#alert_message', 'success', 'replace', true);
        }).error(function (data) {
            displayTailwindAlert('Feil!', parseResponseError(data), '#alert_message', 'error', 'replace', true);
        }).always(function () {
            ajaxLockActive = false;
        });
        return false;
    }

    function initSortable() {
        const listElement = $('#wa_product_category_wrapper #wa_product_categories_list', document)[0];

        if (!listElement || !$('#wa_product_category_wrapper .wa_product_category_item', document).length || typeof Sortable !== 'function') {
            return;
        }

        if (listElement.waProductCategorySortable) {
            listElement.waProductCategorySortable.destroy();
        }

        listElement.waProductCategorySortable = new Sortable(listElement, {
            animation: 150,
            draggable: '.wa_product_category_item',
            handle: '.wa_product_category_drag_handle',
            ghostClass: 'opacity-50',
            onUpdate: function () {
                updateSortPriority();
            }
        });
    }

    initSortable();

    function getProductItemRow(itemData) {
        const template = document.querySelector('#wa_product_category_product_row_template');

        if (!template) {
            return null;
        }

        const row = template.content.firstElementChild.cloneNode(true);
        const rowElement = $(row);

        rowElement.find('.wa_product_category_product_name').text(itemData.product_name);
        rowElement.find('.wa_product_category_product_sku').text(itemData.varenummer);
        rowElement.find('.wa_product_category_toggle_product_btn').attr('data-product-id', itemData.product_id);

        return row;
    }

    $(document).on('click', '#wa_product_category_wrapper #wa_product_category_btn_create', function () {
        if (ajaxLockActive) {
            return false;
        }

        const name = $('#wa_product_category_wrapper #wa_product_category_name', document).val();
        const iconName = $('#wa_product_category_wrapper #wa_product_category_icon_preview', document).attr('data-icon-name');

        const productIds = [];
        $('#wa_product_category_wrapper .wa_product_category_toggle_product_btn', document).each(function (_, element) {
            const productId = $(element).attr('data-product-id');
            const isAddedToCategory = $(element).attr('data-added-to-category');

            if (isAddedToCategory == 1) {
                productIds.push(productId);
            }
        });

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'POST',
            url: ajaxPathProductCategory,
            data: {
                name: name,
                icon_name: iconName,
                product_ids: productIds,
            },
            dataType: 'json'
        }).success(function (data) {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            displayTailwindAlert('Feil!', parseResponseError(data), '#alert_message', 'error', 'replace', true);
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper #wa_product_category_btn_update', function () {
        if (ajaxLockActive) {
            return false;
        }

        const productCategoryId = $('#wa_product_category_wrapper #wa_product_category_id', document).val();
        const name = $('#wa_product_category_wrapper #wa_product_category_name', document).val();
        const iconName = $('#wa_product_category_wrapper #wa_product_category_icon_preview', document).data('icon-name');

        const productIds = [];
        $('#wa_product_category_wrapper .wa_product_category_toggle_product_btn', document).each(function (_, element) {
            const productId = $(element).attr('data-product-id');
            const isAddedToCategory = $(element).attr('data-added-to-category');

            if (isAddedToCategory == 1) {
                productIds.push(productId);
            }
        });

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'POST',
            url: `${ajaxPathProductCategory}/${productCategoryId}`,
            data: {
                name: name,
                icon_name: iconName,
                product_ids: productIds,
            },
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper', document).html(data.html);
            initSortable();
            displayTailwindAlert('Lagret!', 'Produktkategori er oppdatert', '#alert_message', 'success', 'replace', true);
        }).error(function (data) {
            displayTailwindAlert('Feil!', parseResponseError(data), '#alert_message', 'error', 'replace', true);
        }).always(function () {
            hidePreloader();
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper #wa_product_category_btn_delete', function () {
        if (ajaxLockActive) {
            return false;
        }

        const productCategoryName = $('#wa_product_category_wrapper #wa_product_category_name', document).val();

        if (!confirm(`Vil du slette produktkategori "${productCategoryName}"?`)) {
            return;
        }

        const productCategoryId = $('#wa_product_category_wrapper #wa_product_category_id', document).val();

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'DELETE',
            url: `${ajaxPathProductCategory}/${productCategoryId}`,
            dataType: 'json'
        }).success(function (data) {
            window.location.reload();
        }).error(function (data) {
            hidePreloader();
            displayTailwindAlert('Feil!', parseResponseError(data), '#alert_message', 'error', 'replace', true);
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper .wa_product_category_toggle_product_btn', function () {
        if (ajaxLockActive) {
            return false;
        }

        const isAddedToCategory = $(this).attr('data-added-to-category');

        const btn = $(this);
        const primaryClasses = 'bg-primary border-primary text-white hover:bg-primary/90 hover:border-primary/90';
        const dangerClasses = 'bg-danger border-danger text-white hover:bg-danger/90 hover:border-danger/90';

        if (isAddedToCategory == 0) {
            btn.text(btn.attr('data-delete-label'));
            btn.attr('data-added-to-category', 1);
            btn.removeClass(primaryClasses).addClass(dangerClasses);
        }

        if (isAddedToCategory == 1) {
            btn.text(btn.attr('data-add-label'));
            btn.attr('data-added-to-category', 0);
            btn.removeClass(dangerClasses).addClass(primaryClasses);
        }

        return false;
    });

    $(document).on('input', '#wa_product_category_wrapper #wa_products_list_search_input', function () {
        if (ajaxLockActive) {
            return false;
        }

        const searchInput = $(this);
        const productCategoryId = $('#wa_product_category_id', document).val();
        const searchString = searchInput.val();

        const excludeProductIds = [];
        $('#wa_product_category_wrapper .wa_product_category_toggle_product_btn', document).each(function (_, element) {
            const productId = $(element).attr('data-product-id');
            excludeProductIds.push(productId);
        });

        $.ajax({
            type: 'POST',
            url: `${ajaxPathProductCategory}/${productCategoryId}${ajaxPathProductCategorySearchProducts}`,
            data: {
                search_string: searchString,
                exclude_product_ids: JSON.stringify(excludeProductIds),
            },
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper #wa_products_list_search_result', document).html(data.html);
        }).error(function (data) {
            displayTailwindAlert('Feil!', parseResponseError(data), '#alert_message', 'error', 'replace', true);
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper .add-product', function () {
        const itemData = {
            product_id: $(this).attr('data-product-id'),
            product_name: $(this).attr('data-product-name'),
            varenummer: $(this).attr('data-varenummer')
        }

        $('#wa_product_category_wrapper #wa_products_list_empty', document).remove();

        const tbody = $('#wa_product_category_wrapper #wa_products_list table tbody', document);

        const productRow = getProductItemRow(itemData);

        if (productRow) {
            tbody.append(productRow);
        }

        $(this).remove();

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper .wa_product_category_item', function () {
        if (ajaxLockActive) {
            return false;
        }

        const productCategoryId = $(this).attr('data-id');
        setActiveListItem('#wa_product_categories_list .wa_product_category_item', productCategoryId, 'data-id');

        ajaxLockActive = true;
        showPreloader();

        $.ajax({
            type: 'GET',
            url: `${ajaxPathProductCategory}/${productCategoryId}`,
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper #wa_product_category_form', document).html(data.html);
        }).error(function (data) {
            displayTailwindAlert('Feil!', parseResponseError(data), '#alert_message', 'error', 'replace', true);
        }).always(function () {
            hidePreloader();
            ajaxLockActive = false;
        });

        return false;
    });

    $(document).on('click', '#wa_product_category_wrapper .wa_product_category_icon', function () {
        const iconName = $(this).attr('data-icon-name');

        const iconPreview = $('#wa_product_category_wrapper #wa_product_category_icon_preview', document);
        const iconImage = $('<img>', {
            src: `includes/waiterApp/productCategory/icons/${iconName}`,
            alt: iconName,
            class: 'h-8 w-8 object-contain'
        });

        iconPreview.attr('data-icon-name', iconName).empty().append(iconImage);
        $(this).closest('details').removeAttr('open');
    });

    $(document).on('click', '#wa_product_category_wrapper #wa_product_categories_search_button', function () {
        if (ajaxLockActive) {
            return false;
        }

        const searchInput = $('#wa_product_category_wrapper #wa_product_categories_search_input', document);
        const searchString = searchInput.val();

        $.ajax({
            type: 'GET',
            url: ajaxPathProductCategory,
            data: {
                search_string: searchString,
            },
            dataType: 'json'
        }).success(function (data) {
            $('#wa_product_category_wrapper #wa_product_categories_list', document).html(data.html);
            initSortable();
        }).error(function (data) {
            displayTailwindAlert('Feil!', parseResponseError(data), '#alert_message', 'error', 'replace', true);
        }).always(function () {
            ajaxLockActive = false;
        });

        return false;
    });
});
